import { helper } from '@ember/component/helper';
import { htmlSafe } from '@ember/template';
import { SafeString } from 'handlebars';
import numeral from 'numeral';
import { isV2Page } from 'uplisting-frontend/helpers/is-v2-page';

export const formatPrice = (price: number): string =>
  numeral(Math.abs(price)).format('0,0.00');

export function priceFormat([
  price,
  currencyClass,
  raw = false,
  withIcon = true,
  textTruncate = false,
]: [number | string, string | undefined, boolean, boolean, boolean]):
  | SafeString
  | string {
  const value = typeof price === 'string' ? Number(price) : price;
  const formattedPrice = formatPrice(value);

  if (!withIcon) {
    return formattedPrice;
  }

  const beforeBadgeSign = value < 0 ? '&minus;' : '';
  const space = isV2Page() ? ' ' : '';

  const output = `<span class="price-format ${textTruncate ? 'text-truncate' : ''}">${beforeBadgeSign}<span class="currency-badge ${currencyClass}">${space}${formattedPrice}</span></span>`;

  if (raw) {
    return output;
  }

  return htmlSafe(output);
}

export default helper(priceFormat);
